<template>
    <div>
        <div class="container-fluid bg-light py-2">
            <div class="row">
                <div class="col-sm-3 col-6">
                    <router-link :to="{ name: 'home' }" class="">
                        <img :src="logo" class="logo" alt="aNewItem Logo">
                    </router-link>
                </div>
                <!-- display the main search bar in header for desktop view -->
                <div class="col-sm-6 col-12 pl-4 pr-0 d-none d-sm-block">
                    <!-- import search bar -->
                    <app-search v-if="headerSearchBar"></app-search>
                </div>
                <div class="col-sm-3 col-6 text-right">
                    <router-link :to="{ name: 'shopping-cart' }" tag="button" class="btn btn-light bg-white border-dark mr-2 px-1 py-1">
                        <i class="fas fa-shopping-cart"></i> <app-cart-counter class="font-weight-bold text-danger"></app-cart-counter>
                    </router-link>
                    <button @click.prevent="showMenu = !showMenu" class="btn btn-light-green py-1 d-md-none">
                        <i class="fas fa-bars fa-lg"></i>
                    </button>
                    <button @click.prevent="showMenu = !showMenu" class="btn btn-light-green py-1 d-none d-md-inline">
                        <i class="fas fa-bars"></i> MENU
                    </button>
                </div>
            </div>
        </div>
        
        <!-- display the main search bar in header for mobile view -->
        <div v-if="headerSearchBar" class="d-sm-none">
            <app-search></app-search>
        </div>

        <!-- import the menu component -->
        <div class="d-sm-none">
            <template v-if="showMenu">
                <div class="side-menu-overlay">
                    <div class="h-100" @click.prevent="closeMenuFxn"></div>
                    <app-menu :menuClass="'side-menu'" @emitCloseMenuFxn="closeMenuFxn"></app-menu>
                </div>
            </template>
        </div>
        <div class="d-none d-sm-block">
            <template v-if="showMenu">
                <app-menu :menuClass="'top-menu'" @emitCloseMenuFxn="closeMenuFxn"></app-menu>
                <div class="top-menu-overlay" @click.prevent="closeMenuFxn"></div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CartCounter from '@/components/general/pages/homeParts/CartCounter.vue';
import Search from '@/components/general/pages/Search.vue';
import Menu from '@/components/general/shared/Menu.vue';

export default {
    name: "Header",
    data() {
        return {
            logo: require('../../../assets/anewitem.png'),
            showMenu: false
        }
    },
    methods: {
        closeMenuFxn() {
            this.showMenu = false
        },
    },
    computed: {
        ...mapGetters(['authenticated', 'user', 'headerSearchBar'])
    },
    components: {
        appSearch: Search,
        appMenu: Menu,
        appCartCounter: CartCounter
    },
}
</script>